import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ChangePasswordModel } from '../../../models/recovery/change-password.model';
import * as Actions from './recovery.action';
import * as Selectors from './recovery.selector';

@Injectable()
export class RecoveryFacade {
  changePassword$ = this.store.select(Selectors.selectchangePassword);
  userByRecoveryEncryptedId$ = this.store.select(Selectors.selectUserByRecoveryEncryptedId);

  constructor(private store: Store) { }

  public changePassword(model: ChangePasswordModel): void {
    this.store.dispatch(Actions.ChangePassword({ changeRequest: model }));
  }

  public getUserByRecoveryEncryptedId(encryptedId: string): void {
    this.store.dispatch(Actions.GetUserByRecoveryEncryptedId({ encryptedId }));
  }

}
